import { RiskItem } from "components/summary/success-plan/context/SuccessPlanContext";

export type RelationshipLevel = {
  label: string;
  value: string;
};

export const riskItems: RiskItem[] = [
  {
    key: "not-applicable",
    value: "Not Applicable",
    color: "#121212",
    backgroundColor: "#E0E0E0",
    priority: 0,
  },
  {
    key: "minimal-risk",
    value: "Minimal Risk",
    color: "green",
    backgroundColor: "#ffeb9c",
    priority: 1,
  },
  {
    key: "moderate-risk",
    value: "Moderate Risk",
    color: "#F26B1D",
    backgroundColor: "#FCE1D2",
    priority: 2,
  },
  {
    key: "significant-risk",
    value: "Significant Risk",
    color: "#c23e25",
    backgroundColor: "#ffc7ce",
    priority: 3,
  },
];

export const relationshipLevels: RelationshipLevel[] = [
  { label: "IT Admin", value: "IT Admin" },
  { label: "IT Director", value: "IT Director" },
  { label: "IT VP Level", value: "IT VP Level" },
  { label: "LOB", value: "LOB" },
  { label: "Other", value: "Other" },
];

export const csmValidateFields: { [key: number]: string[] } = {
  0: ["customerRisk", "certifyFlag", "customerRiskNote"],
  1: [
    "deviceRisk",
    "deviceRiskNote",
    "meetingRisk",
    "meetingRiskNote",
    "callingRisk",
    "callingRiskNote",
    "contactCenterRisk",
    "contactCenterRiskNote",
  ],
  2: [],
};

export const YNOptions = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

export const ContractTypeOptions = [
  { value: "E3", label: "E3" },
  { value: "E5", label: "E5" },
  { value: "Unknown", label: "Unknown" },
];

export const HighTouchSegmentOptions = [
  { value: "Advocate", label: "Advocate" },
  { value: "Invested", label: "Invested" },
  { value: "Unresponsive", label: "Unresponsive" },
  { value: "Dormant", label: "Dormant" },
];
